import { Invite } from './invite-model';
import { PagedList } from './pagination';

export class InviteGrid {
    invites: Invite[] = [];
    isOriginatorUser: boolean;
}

export class PagedInviteGridDto {
    apiEnabledInvites: PagedList<Invite>;
    notificationSignatureInProgress: boolean;
    isOriginatorUser: boolean;
}
